

export class Family {
    public Id = 0;
    public Title = '';
    public Symbol: string;
    public ExistingCount = 0;
    public Checked:boolean=false;
}

export class GenericIdName {
    public Id: number;
    public Name: string;
    public Checked:boolean =false;
    public ImplementTypeId:number;
}

export class GenericIdName_ {
    public Id: number;
    public Name: string;
    public Symbol?: string | null;
}

export class ImplementLoadVM{
    customer:number[];
    models:number[];
}

export class ComponentTypeList {
    public Id: number;
    public Name: string;
    public Checked:boolean;
    public SchematicImages:string[];
}
export class UpdateCustomerVM{
    public formId:number;
    public selectedList:number[];
}

export class FormHeaderVM{
    public Id:number;
    public standardField:number;
    public fieldname:string;
    public qid:number;
    public order:number;
}

export class DigitalFormDataVM{
    public DigitalForms:DigitalFormVM;
    public CategorySections: DigitalFormQuestionsCategoriesVM[];
    public ParentCategories: DigitalFormQuestionsCategoriesVM[];
    public Questions: DigitalFormQuestionsVM[];
    public QuestionTypes : DigitalFormQuestionTypesVM[];

}
export class DigitalFormVM{
    public FormId:number;
    public FormName:string;
    public FormCategoeryId:number;
    public Active:boolean;
    public EmailonComplete:boolean;
    public customerId:number[];
    public familyId:number[];
    public modelId:number[];
    public StartByInspector:boolean;
    public FECRForm:boolean;
    public FECRInspectionType:number;
    public FormLinkedTemplateId:number[];
    public jobsiteId:number[];
    public StartBySupervisor:boolean;
}

export class DigitalFormQuestionsCategoriesVM{
        public  QuestionCatId :number;
        public  QCategoryName :string;
        public  FormId :number;
        public  Order :number;
        public  QuestionCount: number;
        public  IsParent:boolean;
        public  ParentCatId :number;
        public  SectionCount:number;
        public Active:boolean;
}

export class DigitalFormQuestionsVM {
    public  QuestionId :number
        public  QTitle:string
        public  QDescription:string;
        public  Active:boolean; 
        public  AllowImages :boolean; 
        public  AllowComments:boolean; 
        public  FormId :number
        public  QuestionTypeId:number
        public  HasQuestionImage :boolean; 
        public   QuestionCatId :number
        public  Order :number
        public  ImageEdit :boolean; 
        public  QuestionTypeName :string;
        public  QuestionNumber :number
        public  QuestionImage :string;
        public  ModelAnswers:ModelAnswerList[]; 
        public UploadImages :string[];
        public  EditedQuestionImage :string;
        public isIncludeHeader:boolean=false;
}

export class ModelAnswerList{
    public  AnswerId :number;
        public  QuestionId:number;
        public  Answer :string;
        public  select :boolean;
       public  QuestionName :string;
        
}

export class DigitalFormQuestionTypesVM{
    public Id:number;
    public Title:string;
}

export class AddQuestionVM{
    QuestionId:number;
    FormId:number;
    QTitile:string;
    QDescription:string;
    QuestionTypeID:number;
    AllowImageEdit:boolean;
    AllowImages:boolean;
    QuestionImage:string;
    QuestionAnswer:QuestionAnswerList[];
    ImplementTypeId:number;
    QuestionSectionId:number;
    Active:boolean;
    HasQuestionImage:boolean;
    Order:number;
    ComponentTypeId:number[];
    IsCopy:boolean;
    IsParent:boolean;
    IsRemoveLink:number;
    isEditQ:number;
    OptionUpdate:boolean;
    ComponentId:number[];
    IsMagnetic:boolean;
    IsComponentConnect:boolean;
    IsActiveLimits:boolean;
    StartWornNum:number;
    EndWornNum:number;
    DecimalPlaces:number;
    UnitMeasureType:string;
    IsAnswerMandatory:boolean;
}

export class QuestionAnswerList{
    formId:number;
    Answer:string;
    AnswerId:number;
    WornStart:number;
    WornEnd:number;
}

export class CompListVM{
    FormId:number;
    compoenetTypeIds:number[]
}

export class UnitMeasureVM{
    UnitId:number;
    UnitMeasure:string;
    UnitTypeId:number;
}

export class UnitMeasureDto{
   Data:UnitMeasureVM[];
   Status:number;
   Message:string;
}

export class FamilyVM {
  id: number;
  title: string;
  symbol: string;
  count: number;
}

export class FamilyDto {
  Data: FamilyVM[];
  Status: number;
  Message: string;
}
